import Observable from './observable';
import Subject from './subject';
export default class TransformSubject extends Observable {
    constructor(transform) {
        super((observer) => {
            const subscription = this.output.subscribe(observer);
            return () => {
                subscription.unsubscribe();
            };
        });
        this.input = new Subject();
        this.output = transform(this.input);
    }
    next(value) {
        this.input.next(value);
    }
}
//# sourceMappingURL=transform-subject.js.map